@if (!loading) {
  <div class="app-root-wrap">
    <router-outlet></router-outlet>
  </div>
}

@if (loading) {
  <div class="vertical-center loader-container">
    <div class="loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
